
/* Labels uit locales: de teller stond hardcoded in het Engels ("2 items"),
   ook op een Italiaanse of Poolse markt. De vormen komen uit een data-attribuut
   dat Liquid vult; een lege vertaling is een geldige vertaling. */
function wishlistAantalTekst(n) {
  var houder = document.getElementById('cnv-wishlist-count-text');
  var een = houder && houder.getAttribute('data-een');
  var meer = houder && houder.getAttribute('data-meer');
  var sjabloon = n === 1 ? een : meer;
  if (!sjabloon) return String(n);
  return sjabloon.replace('__n__', n);
}
/**
 * Casanuva Wishlist — localStorage-based
 */
(function() {
  /* Inject active-state CSS */
  var style = document.createElement('style');
  style.textContent =
    '.cnv-card__wish--active svg { fill: #8B6344 !important; stroke: #8B6344 !important; }' +
    '.cnv-card__wish--active { opacity: 1 !important; }' +
    '.cnv-wish--active svg { fill: #8B6344 !important; stroke: #8B6344 !important; }' +
    '.wsh.cnv-wish--active { color: #8B6344; background: none !important; }';
  document.head.appendChild(style);

  var STORAGE_KEY = 'cnv_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch(e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateAllHearts();
    updateHeaderBadge();
  }

  function isWished(productId) {
    return getWishlist().some(function(item) { return item.id == productId; });
  }

  function toggleWishlist(productId, productUrl, productTitle, productImage, productPrice) {
    var list = getWishlist();
    var idx = list.findIndex(function(item) { return item.id == productId; });
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({
        id: productId,
        url: productUrl,
        title: productTitle,
        image: productImage,
        price: productPrice
      });
    }
    saveWishlist(list);
  }

  function updateAllHearts() {
    // Product cards
    document.querySelectorAll('.cnv-card__wish').forEach(function(btn) {
      var card = btn.closest('[data-product-id]');
      if (!card) return;
      var id = card.getAttribute('data-product-id');
      btn.classList.toggle('cnv-card__wish--active', isWished(id));
    });

    // PDP wishlist button
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var id = btn.getAttribute('data-wishlist-toggle');
      btn.classList.toggle('cnv-wish--active', isWished(id));
    });
  }

  function updateHeaderBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('.cnv-wishlist-count').forEach(function(el) {
      if (count > 0) {
        el.textContent = count;
        el.style.display = 'flex';
      } else {
        el.style.display = 'none';
      }
    });
  }

  // Card wishlist buttons
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cnv-card__wish');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('[data-product-id]');
    if (!card) return;

    var id = card.getAttribute('data-product-id');
    var link = card.querySelector('.cnv-card__link');
    var img = card.querySelector('.cnv-card__img-primary');
    var name = card.querySelector('.cnv-card__name');
    var price = card.querySelector('.cnv-card__price');

    toggleWishlist(
      id,
      link ? link.getAttribute('href') : '',
      name ? name.textContent.trim() : '',
      img ? img.getAttribute('src') : '',
      price ? price.textContent.trim() : ''
    );
  });

  // PDP wishlist button
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();

    var id = btn.getAttribute('data-wishlist-toggle');
    var title = btn.getAttribute('data-wishlist-title') || '';
    var url = btn.getAttribute('data-wishlist-url') || '';
    var image = btn.getAttribute('data-wishlist-image') || '';
    var price = btn.getAttribute('data-wishlist-price') || '';

    toggleWishlist(id, url, title, image, price);
      // Swap heart character on PDP button
      if (btn.classList.contains('wsh')) {
        btn.innerHTML = isWished(id) ? '♥' : '♡';
      }
  });

  // Wishlist page rendering
  function renderWishlistPage() {
    var container = document.getElementById('cnv-wishlist-grid');
    if (!container) return;

    var list = getWishlist();
    var empty = document.getElementById('cnv-wishlist-empty');

    if (list.length === 0) {
      container.style.display = 'none';
      if (empty) empty.style.display = 'block';
      return;
    }

    if (empty) empty.style.display = 'none';
    container.style.display = 'grid';
    container.innerHTML = '';

    list.forEach(function(item) {
      var card = document.createElement('div');
      card.className = 'cnv-wishlist-card';
      card.innerHTML =
        '<a href="' + item.url + '" class="cnv-wishlist-card__img">' +
          (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="cnv-wishlist-card__info">' +
          '<a href="' + item.url + '" class="cnv-wishlist-card__name">' + item.title + '</a>' +
          '<div class="cnv-wishlist-card__price">' + item.price + '</div>' +
        '</div>' +
        '<button class="cnv-wishlist-card__remove" data-remove-wish="' + item.id + '" aria-label="Remove">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>';
      container.appendChild(card);
    });

    document.getElementById('cnv-wishlist-count-text').textContent = wishlistAantalTekst(list.length);
    verversUitMarkt(list, container);
  }

  /* Titel, prijs en link komen uit localStorage: ze zijn opgeslagen op het moment
     van toevoegen, in de taal en valuta van dat moment. Wie een product op de
     Engelse markt bewaarde en later Pools kiest, ziet daar een Engelse naam met
     een dollarprijs naast Poolse producten staan. Deze fetch gaat door de huidige
     markt en werkt alle drie bij; de opgeslagen waarden blijven de tussenstand,
     zodat de kaart nooit leeg is. Lukt de aanvraag niet, dan blijft er staan wat
     er stond — een verouderde naam is beter dan een gat. */
  function verversUitMarkt(list, container) {
    var wortel = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/*$/, '/');
    list.forEach(function (item, i) {
      var deel = String(item.url || '').split('/products/')[1];
      if (!deel) return;
      var handle = deel.split('?')[0].split('#')[0];
      fetch(wortel + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          var kaart = container.children[i];
          if (!kaart) return;
          var naam = kaart.querySelector('.cnv-wishlist-card__name');
          if (naam && data.title) naam.textContent = data.title;
          var beeld = kaart.querySelector('img');
          if (beeld && data.title) beeld.setAttribute('alt', data.title);
          var prijs = kaart.querySelector('.cnv-wishlist-card__price');
          if (prijs && window.cnvGeld) prijs.textContent = window.cnvGeld.opmaakCenten(data.price);
          kaart.querySelectorAll('a').forEach(function (a) {
            a.setAttribute('href', wortel + 'products/' + handle);
          });
        })
        .catch(function () { /* laat de opgeslagen waarden staan */ });
    });
  }

  // Remove from wishlist page
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-remove-wish]');
    if (!btn) return;
    var id = btn.getAttribute('data-remove-wish');
    var list = getWishlist().filter(function(item) { return item.id != id; });
    saveWishlist(list);
    renderWishlistPage();
  });

  // Init
  updateAllHearts();
  updateHeaderBadge();
  renderWishlistPage();
})();
